/**
 * Created by slava on 3/31/17.
 */

cleverapps.Notification = function () {
    this.queue = [];
    this.current = undefined;

    this.onRemove = function () {};
    this.onUpdateProgress = function () {};
};

cleverapps.Notification.prototype.create = function (msg, options) {
    options = options || {};

    if (!options.debugInfo && !msg) {
        return;
    }

    if (this.current && msg === this.current.msg) {
        if (options.progress) {
            this.onUpdateProgress(
                options.progress.newAmount ? options.progress.newAmount : options.progress.amount,
                options.progress.total
            );
        }
        return;
    }

    let findedInQueue = false;
    this.queue.forEach((current) => {
        if (current.msg === msg) {
            if (options.progress && current.options.progress) {
                if (options.progress.newAmount) {
                    current.options.progress.newAmount = options.progress.newAmount;
                } else {
                    current.options.progress = options.progress;
                }
            }
            findedInQueue = true;
        }
    });
    if (findedInQueue) {
        return;
    }

    this.queue.push({
        msg,
        options
    });
    if (this.queue.length > cleverapps.Notification.MAX_QUEUE) {
        this.queue.shift();
    }

    if (!options.defer) {
        this.processQueue();
    }
};

cleverapps.Notification.prototype.processQueue = function () {
    if (this.current || !this.queue.length) {
        return;
    }

    const parent = cleverapps.Scenes.GetRunningScene();
    if (!parent) {
        return;
    }

    if (!this.canShow(this.queue[0])) {
        return;
    }

    const data = this.queue.shift();

    this.current = {
        msg: data.msg
    };

    const notificationView = new NotificationView(this, data.msg, data.options);
    parent.addChild(notificationView);
    notificationView.show();
};

cleverapps.Notification.prototype.reset = function () {
    this.onRemove();
    this.current = undefined;
};

cleverapps.Notification.prototype.clear = function () {
    this.reset();
    this.queue = [];
};

cleverapps.Notification.prototype.canShow = function (notification) {
    if (cleverapps.gameModes.noNotifications) {
        return false;
    }
    return cleverapps.allInitialized && !cleverapps.environment.isLoaderScene() && cleverapps.Scenes.GetRunningScene().sceneComponent.isSceneReady() || notification.options.debugInfo;
};

cleverapps.Notification.MAX_QUEUE = 3;
